import { initializeApp, getApps, getApp } from 'firebase/app'
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics'
import logger from '@/assets/js/logger.js'

/** Firebase Web 客户端配置（apiKey 可公开；生产环境建议在控制台限制域名与 API Key） */
export const firebaseConfig = {
  apiKey: 'AIzaSyCTnJnzoIp12ufZyp32QgwCm09tlWSbGNw',
  authDomain: 'dailyshort-baab8.firebaseapp.com',
  projectId: 'dailyshort-baab8',
  storageBucket: 'dailyshort-baab8.firebasestorage.app',
  messagingSenderId: '658984802889',
  appId: '1:658984802889:web:d3c4fdb94e5c829d81bd98',
  measurementId: 'G-R728NMHX1D'
}

export function getFirebaseApp () {
  if (!getApps().length) {
    return initializeApp(firebaseConfig)
  }
  return getApp()
}

let analytics = null

/**
 * 在浏览器中初始化 Analytics（不支持的环境会静默跳过）
 * @returns {Promise<import('firebase/analytics').Analytics | null>}
 */
export async function initFirebaseAnalytics () {
  if (typeof window === 'undefined') return null
  try {
    const supported = await isSupported()
    if (!supported) return null
    analytics = getAnalytics(getFirebaseApp())
    return analytics
  } catch {
    return null
  }
}

/**
 * 上报 GA4 事件（Analytics 未就绪时无操作）
 * @param {string} name
 * @param {Record<string, unknown>} [params]
 */
export function logAnalyticsEvent (name, params = {}) {
  if (!analytics) {
    logger.debug('[Firebase/Analytics] skipped (not initialized)', name, params)
    return
  }
  logger.debug('[Firebase/Analytics] logEvent', name, params)
  logEvent(analytics, name, params)
}

export function getFirebaseAnalytics () {
  return analytics
}
